<template>
  <v-row>

    <!-- 都道府県名 -->
    <v-col cols="12">
      <c-prefecture :name="area.pref"/>
    </v-col>

    <!-- ステーションカード -->
    <v-col
      v-for="st in area.stations"
      :key="st.stationID"
      cols="12" sm="6"
    >
      <c-station-card :station="st"/>
    </v-col>

  </v-row>
</template>

<script>
import CPrefecture from './CPrefecture'
import CStationCard from './CStationCard'

export default {
  name: 'CArea',
  components: {
    CPrefecture,
    CStationCard
  },

  props: {
    area: {
      type: Object,
      required: true
    }
  }
}
</script>
